import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  Box,
  Typography,
  TextField,
  ButtonGroup,
  Button,
  Divider,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import { Col, Row, Form } from "react-bootstrap";

const LapPenerimaanLebihDari1x = () => {
  const tableRef = useRef(null);
  const { user } = useContext(AuthContext);
  let date = new Date();
  let [inputDariTgl, setInputDariTgl] = useState(date);
  let [inputSampaiTgl, setInputSampaiTgl] = useState(date);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapPenerimaanLebihDari1x, setLapPenerimaanLebihDari1x] = useState([]);

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  useEffect(() => {}, []);

  const getLapPenerimaanLebihDari1x = async () => {
    setLoading(true);
    setPersenLoading("10");
    const response = await axios.post(`${tempUrl}/lapPenerimaanLebihDari1x`, {
      dariTgl: inputDariTgl,
      sampaiTgl: inputSampaiTgl,
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setLapPenerimaanLebihDari1x(response.data);
    setPersenLoading("0");
    setLoading(false);
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LapPenerimaanLebihDari1x",
    sheet: "LapPenerimaanLebihDari1x",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Box>
      <Typography color="#757575">Laporan</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Laporan Penerimaan {">"} 1x Bayar
      </Typography>
      <Divider sx={dividerStyle} />
      <Box sx={showDataWrapper}>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Dari Tanggal :
              </Form.Label>
              <Col sm="9">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={inputDariTgl}
                  onChange={(e) => setInputDariTgl(e)}
                  customInput={
                    <TextField
                      error={error && inputDariTgl === null && true}
                      helperText={
                        error &&
                        inputDariTgl === null &&
                        "Dari Tanggal harus diisi!"
                      }
                      sx={{ width: "100%" }}
                      size="small"
                    />
                  }
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Sampai Tanggal :
              </Form.Label>
              <Col sm="9">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={inputSampaiTgl}
                  onChange={(e) => setInputSampaiTgl(e)}
                  customInput={
                    <TextField
                      error={error && inputSampaiTgl === null && true}
                      helperText={
                        error &&
                        inputSampaiTgl === null &&
                        "Sampai Tanggal harus diisi!"
                      }
                      sx={{ width: "100%" }}
                      size="small"
                    />
                  }
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
      </Box>
      <Box sx={spacingTop}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={() => {
              getLapPenerimaanLebihDari1x();
            }}
          >
            LIHAT
          </Button>
        </ButtonGroup>
      </Box>
      {lapPenerimaanLebihDari1x.length > 0 && (
        <>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<DownloadIcon />}
            sx={{ marginTop: "10px" }}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        </>
      )}
      <table
        ref={tableRef}
        style={{
          visibility:
            lapPenerimaanLebihDari1x.length > 0 ? "visible" : "hidden",
        }}
      >
        <tbody>
          <tr>
            <th>kwitansi</th>
            <th>tanggal</th>
            <th>j_tempo</th>
            <th>kode_ar</th>
            <th>customer</th>
            <th>no_plat</th>
            <th>kode_svy</th>
            <th>surveyor</th>
            <th>angsuran</th>
            <th>ke</th>
            <th>keterangan</th>
            <th>status</th>
          </tr>
          {lapPenerimaanLebihDari1x.map((item, i) => (
            <tr>
              <th>{item.kwitansi}</th>
              <th>{item.tanggal}</th>
              <th>{item.j_tempo}</th>
              <th>{item.kode_ar}</th>
              <th>{item.customer}</th>
              <th>{item.no_plat}</th>
              <th>{item.kode_svy}</th>
              <th>{item.surveyor}</th>
              <th>{item.angsuran}</th>
              <th>{item.ke}</th>
              <th>{item.keterangan}</th>
              <th>{item.status}</th>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default LapPenerimaanLebihDari1x;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  mt: 2,
};

const spacingTop = {
  mt: 4,
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  // maxWidth: {
  //   md: "40vw"
  // }
};
